export default __webpack_public_path__ + "static/media/banner-ico.2a739d89.svg";